export enum ControlTypes {
  CodeBooks = "codeBooks",
  CustomContentMaintenance = "customContentMaintenance",
  References = "references",
  Research = "research",
}

export enum WindowId {
  CodeBooks = "STANDALONE_CODEBOOKS",
  References = "STANDALONE_REFERENCES",
  EncounterCodeBooks = "ENCOUNTER_CODEBOOKS",
}

export const ResearchPaneTabs = {
  DRG_ANALYSIS: "drgAnalysis",
  RESEARCH: "research",
  EDITS: "edits",
  EM: "em",
} as const;

export type ResearchPaneTabsType = (typeof ResearchPaneTabs)[keyof typeof ResearchPaneTabs];

export const ResearchPaneTabIds = {
  DRG_ANALYSIS: "tab-drg-analysis",
  RESEARCH: "tab-research",
  EDITS: "tab-edits",
  EM: "tab-em",
} as const;
